import React, { useState, useEffect } from "react";
import {
  Table,
  Row,
  Col,
  Button,
  Card,
  Container,
  Modal,
  Form,
  InputGroup,
  FormControl,
  Spinner,
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../layout/Layout";

// API cagri fonksiyonlarini import et
import {
  getCustomerDetail,
  addCustomerNote,
  updateCustomerNote,
  deleteCustomerNote,
  addCustomerQualityRequirement,
  updateCustomerQualityRequirement,
  deleteCustomerQualityRequirement,
  uploadCustomerDocument,
  updateCustomerDocument,
  deleteCustomerDocument,
  downloadCustomerDocument, // İndirme API'si eklendi
} from "../../../api/disticaret/customerApi";

// --- MOCK PERMISSIONS ---
const CURRENT_USER_PERMISSIONS = [
  "customer_document_upload",
  "customer_document_update",
  "customer_document_delete",
  "customer_note_post",
  "customer_note_update",
  "customer_note_delete",
  "customer_quality_post",
  "customer_quality_update",
  "customer_quality_delete",
];

// --- SVG ICONS ---
const Icons = {
  File: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  Shield: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  Alert: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  ),
  Check: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#198754"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  Briefcase: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
  ),
  Plus: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Edit: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  ),
  Trash: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  ),
  Filter: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
    </svg>
  ),
  Download: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  ),
};

// Tarih formatlama helper'i
const formatDate = (dateObj) => {
  if (!dateObj) return "-";
  const dateStr = typeof dateObj === "string" ? dateObj : dateObj.$date;
  if (!dateStr) return "-";

  const d = new Date(dateStr);
  return d.toLocaleDateString("tr-TR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// ID cikarici helper ($oid icin)
const getId = (idObj) => {
  if (!idObj) return "";
  return typeof idObj === "string" ? idObj : idObj.$oid;
};

// Kisi adini guvenli sekilde gosterme helper'i
const getUserFullName = (userObj) => {
  if (!userObj) return "-";
  if (typeof userObj === "string") return userObj;

  if (userObj.name && userObj.surname) {
    return `${userObj.name} ${userObj.surname}`;
  }

  if (userObj.firstName && userObj.lastName)
    return `${userObj.firstName} ${userObj.lastName}`;
  if (userObj.name) return userObj.name;
  if (userObj.fullName) return userObj.fullName;

  return "Bilinmeyen Kullanici";
};

export default function CustomerDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dateFilter, setDateFilter] = useState("");

  const [modalType, setModalType] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [docForm, setDocForm] = useState({ title: "", description: "" });
  const [noteForm, setNoteForm] = useState({
    title: "",
    content: "",
    priority: "Normal",
  });
  const [qualityForm, setQualityForm] = useState({
    title: "",
    description: "",
  });

  const hasPermission = (perm) => CURRENT_USER_PERMISSIONS.includes(perm);

  // --- API RESPONSE HANDLER ---
  const handleApiResponse = (response) => {
    if (response.status === 401) {
      sessionStorage.removeItem("token");
      navigate("/login");
      throw new Error("Oturumunuz sonlandı.");
    }
    if (response.status === 403) {
      alert("Bu işlem için yetkiniz bulunmamaktadır.");
      throw new Error("Yetkisiz işlem.");
    }
    return response;
  };

  // --- API: DETAY GETİRME ---
  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await getCustomerDetail(id);
      handleApiResponse(response);

      const responseData = response.data?.data || response.data;
      if (responseData) {
        const customerData = Array.isArray(responseData)
          ? responseData[0]
          : responseData;
        setData(customerData);
      } else {
        setData(null);
      }
    } catch (error) {
      console.error("Detay bilgisi çekilirken hata oluştu", error);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getPriorityBadge = (priority) => {
    switch (priority) {
      case "Yuksek":
      case "Yüksek":
        return (
          <span className="text-warning small fw-bold d-flex align-items-center gap-1">
            <Icons.Alert /> Yüksek
          </span>
        );
      case "Kritik":
        return (
          <span className="text-danger small fw-bold d-flex align-items-center gap-1">
            <Icons.Alert /> Kritik
          </span>
        );
      default:
        return (
          <span className="text-secondary small fw-medium d-flex align-items-center gap-1">
            Normal
          </span>
        );
    }
  };

  // --- HANDLERS: MODALS ---
  const openDocModal = (item = null) => {
    setModalType("document");
    setSelectedFile(null);

    if (item) {
      setIsEditing(true);
      setCurrentItem(item);
      setDocForm({
        title: item.title || "",
        description: item.description || "",
      });
    } else {
      setIsEditing(false);
      setDocForm({ title: "", description: "" });
    }
  };

  const openNoteModal = (item = null) => {
    setModalType("note");
    if (item) {
      setIsEditing(true);
      setCurrentItem(item);
      setNoteForm({
        title: item.title,
        content: item.content,
        priority: item.priority,
      });
    } else {
      setIsEditing(false);
      setNoteForm({ title: "", content: "", priority: "Normal" });
    }
  };

  const openQualityModal = (item = null) => {
    setModalType("quality");
    if (item) {
      setIsEditing(true);
      setCurrentItem(item);
      setQualityForm({ title: item.title, description: item.description });
    } else {
      setIsEditing(false);
      setQualityForm({ title: "", description: "" });
    }
  };

  // --- API İŞLEMLERİ ---

  // 1 & 2. Doküman Yükleme ve Güncelleme
  const saveDoc = async () => {
    if (!isEditing && !selectedFile) {
      alert("Lütfen bir dosya seçin.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("title", docForm.title);
      formData.append("description", docForm.description);

      if (selectedFile) {
        formData.append("file", selectedFile);
      }

      let response;

      if (isEditing && currentItem) {
        formData.append("documentId", getId(currentItem._id));
        response = await updateCustomerDocument(formData);
      } else {
        response = await uploadCustomerDocument(formData);
      }

      handleApiResponse(response);

      if (response.data?.success || response.data?.statusCode === 200) {
        setModalType(null);
        fetchDetail();
      } else {
        alert("İşlem sırasında bir sorun oluştu.");
      }
    } catch (error) {
      console.error("Doküman kaydetme/güncelleme hatası:", error);
    }
  };

  // 3. Doküman Silme
  const deleteDoc = async (docId) => {
    if (!window.confirm("Bu dokümanı silmek istediğinize emin misiniz?"))
      return;

    try {
      const payload = {
        id: id,
        documentId: docId,
      };

      const response = await deleteCustomerDocument(payload);
      handleApiResponse(response);

      if (response.data?.success || response.data?.statusCode === 200) {
        fetchDetail();
      } else {
        alert("Silme işlemi başarısız oldu.");
      }
    } catch (error) {
      console.error("Doküman silme hatası:", error);
    }
  };

  // 4. DOSYA İNDİRME İŞLEMİ (BLOB)
  const handleDownload = async (doc) => {
    try {
      const payload = {
        id: id,
        documentId: getId(doc._id),
      };

      // responseType: "blob" olduğu için data doğrudan dosya içeriği olarak gelir
      const response = await downloadCustomerDocument(payload);

      // Blob objesini URL'e çeviriyoruz
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Görünmez bir link elementi oluşturup indirmeyi tetikliyoruz
      const link = document.createElement("a");
      link.href = url;
      // İndirilecek dosyanın adını belirliyoruz
      const fileName = doc.originalName || doc.fileName || "indirilen_belge";
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();

      // İşlem bitince DOM'dan temizliyoruz
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Dosya indirme hatası:", error);
      alert("Dosya indirilirken bir hata oluştu.");
    }
  };

  // 5 & 6. Not Ekleme ve Güncelleme
  const saveNote = async () => {
    try {
      const payload = {
        id: id,
        title: noteForm.title,
        content: noteForm.content,
        priority: noteForm.priority,
      };

      let response;

      if (isEditing && currentItem) {
        payload.noteId = getId(currentItem._id);
        response = await updateCustomerNote(payload);
      } else {
        response = await addCustomerNote(payload);
      }

      handleApiResponse(response);

      if (response.data?.success || response.data?.statusCode === 200) {
        setModalType(null);
        fetchDetail();
      } else {
        alert("Not kaydedilirken bir hata oluştu.");
      }
    } catch (error) {
      console.error("Not kaydetme hatası:", error);
    }
  };

  // 7. Not Silme
  const deleteNote = async (noteId) => {
    if (!window.confirm("Bu notu silmek istediğinize emin misiniz?")) return;

    try {
      const payload = {
        id: id,
        noteId: noteId,
      };

      const response = await deleteCustomerNote(payload);
      handleApiResponse(response);

      if (response.data?.success || response.data?.statusCode === 200) {
        fetchDetail();
      } else {
        alert("Silme işlemi başarısız oldu.");
      }
    } catch (error) {
      console.error("Not silme hatası:", error);
    }
  };

  // 8 & 9. Kalite Gereksinimi Ekleme ve Güncelleme
  const saveQuality = async () => {
    try {
      const payload = {
        id: id,
        title: qualityForm.title,
        description: qualityForm.description,
      };

      let response;

      if (isEditing && currentItem) {
        payload.qualityId = getId(currentItem._id);
        response = await updateCustomerQualityRequirement(payload);
      } else {
        response = await addCustomerQualityRequirement(payload);
      }

      handleApiResponse(response);

      if (response.data?.success || response.data?.statusCode === 200) {
        setModalType(null);
        fetchDetail();
      } else {
        alert("Kalite gereksinimi kaydedilirken bir hata oluştu.");
      }
    } catch (error) {
      console.error("Kalite gereksinimi kaydetme hatası:", error);
    }
  };

  // 10. Kalite Gereksinimi Silme
  const deleteQuality = async (qualityId) => {
    if (
      !window.confirm(
        "Bu kalite gereksinimini silmek istediğinize emin misiniz?"
      )
    )
      return;

    try {
      const payload = {
        id: id,
        qualityId: qualityId,
      };

      const response = await deleteCustomerQualityRequirement(payload);
      handleApiResponse(response);

      if (response.data?.success || response.data?.statusCode === 200) {
        fetchDetail();
      } else {
        alert("Silme işlemi başarısız oldu.");
      }
    } catch (error) {
      console.error("Kalite gereksinimi silme hatası:", error);
    }
  };

  // --- YÜKLENİYOR / VERİ YOK DURUMLARI ---
  if (loading) {
    return (
      <Layout>
        <Container
          fluid
          className="py-5 d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <Spinner animation="border" variant="dark" />
        </Container>
      </Layout>
    );
  }

  if (!data) {
    return (
      <Layout>
        <Container
          fluid
          className="py-5 d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div className="text-muted">
            Müşteri bilgisi bulunamadı veya bir hata oluştu.
          </div>
        </Container>
      </Layout>
    );
  }

  const documents = data.documents || [];
  const notes = data.notes || [];
  const qualityRequirements = data.qualityRequirements || [];

  const filteredDocs = documents.filter((doc) => {
    if (!dateFilter) return true;
    const docDate = new Date(doc.addedDate?.$date || doc.addedDate)
      .toISOString()
      .split("T")[0];
    return docDate === dateFilter;
  });

  return (
    <Layout>
      <Container
        fluid
        className="py-4 px-lg-5"
        style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}
      >
        {/* --- HEADER --- */}
        <div className="mb-4 pb-3 border-bottom d-flex justify-content-between align-items-center">
          <div>
            <h2
              className="fw-bold text-dark m-0"
              style={{ letterSpacing: "-0.5px" }}
            >
              {data.companyName}
            </h2>
            <div className="text-muted d-flex align-items-center gap-2 small fw-medium mt-1">
              <span>
                {data.locationDetail} ({data.region})
              </span>
              <span className="text-muted opacity-25">|</span>
              <span className="badge bg-light text-dark border">
                {data.sector}
              </span>
              <span className="text-muted opacity-25">|</span>
              <span>{data.technicalCategory}</span>
            </div>
          </div>
        </div>

        {/* --- DOKÜMANLAR --- */}
        <Card
          className="border-0 shadow-sm mb-4"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          <Card.Header className="bg-white border-bottom py-3 px-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <Icons.File />
              <h6 className="mb-0 fw-bold text-dark">Dokümanlar</h6>
            </div>
            <div className="d-flex gap-2">
              <InputGroup size="sm" style={{ width: "200px" }}>
                <InputGroup.Text className="bg-light border-end-0 text-muted">
                  <Icons.Filter />
                </InputGroup.Text>
                <FormControl
                  type="date"
                  className="border-start-0 ps-0 bg-light"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                />
              </InputGroup>

              {hasPermission("customer_document_upload") && (
                <Button
                  variant="dark"
                  size="sm"
                  className="d-flex align-items-center gap-1"
                  onClick={() => openDocModal()}
                >
                  <Icons.Plus /> Ekle
                </Button>
              )}
            </div>
          </Card.Header>
          <Table hover responsive className="mb-0 align-middle">
            <thead className="bg-light">
              <tr>
                <th className="ps-4 py-3 text-muted small fw-bold text-uppercase border-bottom-0">
                  Dosya Adı
                </th>
                <th className="py-3 text-muted small fw-bold text-uppercase border-bottom-0">
                  Açıklama
                </th>
                <th className="py-3 text-muted small fw-bold text-uppercase border-bottom-0">
                  Yükleyen Kişi
                </th>
                <th className="py-3 text-muted small fw-bold text-uppercase border-bottom-0">
                  Tarih
                </th>
                <th className="text-end pe-4 py-3 text-muted small fw-bold text-uppercase border-bottom-0">
                  İşlem
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredDocs.length > 0 ? (
                filteredDocs.map((doc) => (
                  <tr key={getId(doc._id)}>
                    <td className="ps-4 py-3">
                      <div className="fw-semibold text-dark small">
                        {doc.originalName || doc.fileName}
                      </div>
                      <div
                        className="badge bg-light text-secondary border mt-1 fw-normal"
                        style={{ fontSize: "10px" }}
                      >
                        {doc.fileType?.toUpperCase()}
                      </div>
                    </td>
                    <td className="text-secondary small">{doc.description}</td>
                    <td className="text-dark small fw-medium">
                      {getUserFullName(doc.addedBy)}
                    </td>
                    <td className="text-muted small">
                      {formatDate(doc.addedDate)}
                    </td>
                    <td className="text-end pe-4">
                      {/* İNDİRME BUTONU VE FONKSİYONU EKLENDİ */}
                      <Button
                        variant="light"
                        size="sm"
                        className="p-1 me-2 text-primary bg-primary bg-opacity-10 border-0"
                        onClick={() => handleDownload(doc)}
                      >
                        <Icons.Download /> İndir
                      </Button>

                      {hasPermission("customer_document_update") && (
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 me-2 text-secondary"
                          onClick={() => openDocModal(doc)}
                        >
                          <Icons.Edit />
                        </Button>
                      )}

                      {hasPermission("customer_document_delete") && (
                        <Button
                          variant="link"
                          size="sm"
                          className="p-0 text-danger"
                          onClick={() => deleteDoc(getId(doc._id))}
                        >
                          <Icons.Trash />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4 text-muted small">
                    Kayıt bulunamadı.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>

        <Row>
          {/* --- OPERASYONEL NOTLAR --- */}
          <Col lg={7} className="mb-4">
            <Card
              className="border-0 shadow-sm h-100"
              style={{ borderRadius: "12px" }}
            >
              <Card.Header className="bg-white border-bottom py-3 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <Icons.Briefcase />
                  <h6 className="mb-0 fw-bold text-dark">Operasyonel Notlar</h6>
                </div>
                {hasPermission("customer_note_post") && (
                  <Button
                    variant="outline-dark"
                    size="sm"
                    className="py-0 px-2"
                    style={{ fontSize: "12px" }}
                    onClick={() => openNoteModal()}
                  >
                    + Not Ekle
                  </Button>
                )}
              </Card.Header>
              <Card.Body
                className="p-4"
                style={{
                  backgroundColor: "#F3F4F6",
                  maxHeight: "500px",
                  overflowY: "auto",
                }}
              >
                {[...notes]
                  .sort((a, b) => {
                    const dateA = a.addedDate
                      ? new Date(a.addedDate.$date || a.addedDate).getTime()
                      : 0;
                    const dateB = b.addedDate
                      ? new Date(b.addedDate.$date || b.addedDate).getTime()
                      : 0;
                    return dateB - dateA;
                  })
                  .map((note) => (
                    <Card
                      key={getId(note._id)}
                      className="border-0 shadow-sm mb-3"
                    >
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="fw-bold text-dark small pe-3 text-break">
                            {note.title}
                          </div>
                          <div className="d-flex align-items-center gap-3 flex-shrink-0">
                            <span
                              className="text-muted small"
                              style={{ fontSize: "11px" }}
                            >
                              {formatDate(note.addedDate)}
                            </span>
                            {(hasPermission("customer_note_update") ||
                              hasPermission("customer_note_delete")) && (
                              <div className="d-flex gap-2 border-start ps-2">
                                {hasPermission("customer_note_update") && (
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 text-muted"
                                    onClick={() => openNoteModal(note)}
                                  >
                                    <Icons.Edit />
                                  </Button>
                                )}
                                {hasPermission("customer_note_delete") && (
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 text-danger"
                                    onClick={() => deleteNote(getId(note._id))}
                                  >
                                    <Icons.Trash />
                                  </Button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <p
                          className="mb-2 text-secondary small"
                          style={{ lineHeight: "1.5" }}
                        >
                          {note.content}
                        </p>
                        <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                          <div
                            className="text-muted small"
                            style={{ fontSize: "11px" }}
                          >
                            Ekleyen: {getUserFullName(note.addedBy)}
                          </div>
                          {getPriorityBadge(note.priority)}
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                {notes.length === 0 && (
                  <div className="text-center text-muted small py-4">
                    Henüz not eklenmemiş.
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* --- KALİTE GEREKSİNİMLERİ --- */}
          <Col lg={5} className="mb-4">
            <Card
              className="border-0 shadow-sm h-100"
              style={{ borderRadius: "12px" }}
            >
              <Card.Header className="bg-white border-bottom py-3 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <Icons.Shield />
                  <h6 className="mb-0 fw-bold text-dark">
                    Kalite Gereksinimleri
                  </h6>
                </div>
              </Card.Header>
              <Card.Body
                className="p-0"
                style={{ maxHeight: "440px", overflowY: "auto" }}
              >
                <ul className="list-group list-group-flush">
                  {[...qualityRequirements]
                    .sort((a, b) => {
                      const dateA = a.addedDate
                        ? new Date(a.addedDate.$date || a.addedDate).getTime()
                        : 0;
                      const dateB = b.addedDate
                        ? new Date(b.addedDate.$date || b.addedDate).getTime()
                        : 0;
                      return dateB - dateA;
                    })
                    .map((item) => (
                      <li
                        key={getId(item._id)}
                        className="list-group-item px-4 py-3 border-bottom d-flex justify-content-between align-items-start"
                      >
                        <div className="d-flex gap-3 w-100 min-vw-0">
                          <div className="mt-1 flex-shrink-0">
                            <Icons.Check />
                          </div>
                          <div className="w-100 pe-2">
                            <div className="text-dark small fw-bold mb-1">
                              {item.title}
                            </div>
                            <div className="text-secondary small fw-medium mb-2">
                              {item.description}
                            </div>
                            <div
                              className="d-flex justify-content-between align-items-center text-muted"
                              style={{ fontSize: "10px" }}
                            >
                              <span>{getUserFullName(item.addedBy)}</span>
                              <span>{formatDate(item.addedDate)}</span>
                            </div>
                          </div>
                        </div>
                        {(hasPermission("customer_quality_update") ||
                          hasPermission("customer_quality_delete")) && (
                          <div className="d-flex flex-column gap-2 ms-2 ps-3 border-start flex-shrink-0">
                            {hasPermission("customer_quality_update") && (
                              <Button
                                variant="link"
                                size="sm"
                                className="text-muted p-0 opacity-50 hover-opacity-100"
                                onClick={() => openQualityModal(item)}
                              >
                                <Icons.Edit />
                              </Button>
                            )}
                            {hasPermission("customer_quality_delete") && (
                              <Button
                                variant="link"
                                size="sm"
                                className="text-danger p-0 opacity-50 hover-opacity-100"
                                onClick={() => deleteQuality(getId(item._id))}
                              >
                                <Icons.Trash />
                              </Button>
                            )}
                          </div>
                        )}
                      </li>
                    ))}
                  {qualityRequirements.length === 0 && (
                    <li className="list-group-item px-4 py-4 text-center text-muted small border-bottom-0">
                      Gereksinim bulunamadı.
                    </li>
                  )}
                </ul>
              </Card.Body>
              {hasPermission("customer_quality_post") && (
                <div className="p-3 border-top bg-light mt-auto">
                  <Button
                    variant="outline-dark"
                    size="sm"
                    className="w-100 fw-medium bg-white"
                    onClick={() => openQualityModal()}
                  >
                    + Yeni Madde Ekle
                  </Button>
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </Container>

      {/* --- MODALS --- */}

      {/* 1. Doküman Modalı */}
      <Modal
        show={modalType === "document"}
        onHide={() => setModalType(null)}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fs-6 fw-bold">
            {isEditing ? "Belge Düzenle" : "Belge Yükle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="small">
                Dosya{" "}
                {isEditing && (
                  <span className="text-muted">
                    (Değiştirmek için yeni dosya seçin)
                  </span>
                )}
              </Form.Label>
              {isEditing && currentItem && !selectedFile && (
                <div className="mb-2 small text-primary fw-medium">
                  {currentItem.originalName || currentItem.fileName}
                </div>
              )}
              <Form.Control
                type="file"
                size="sm"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small">Başlık</Form.Label>
              <Form.Control
                type="text"
                value={docForm.title}
                onChange={(e) =>
                  setDocForm({ ...docForm, title: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small">Açıklama</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={docForm.description}
                onChange={(e) =>
                  setDocForm({ ...docForm, description: e.target.value })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" size="sm" onClick={() => setModalType(null)}>
            İptal
          </Button>
          <Button variant="dark" size="sm" onClick={saveDoc}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 2. Not Modalı */}
      <Modal
        show={modalType === "note"}
        onHide={() => setModalType(null)}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fs-6 fw-bold">
            {isEditing ? "Not Düzenle" : "Not Ekle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="small">Başlık</Form.Label>
              <Form.Control
                type="text"
                value={noteForm.title}
                onChange={(e) =>
                  setNoteForm({ ...noteForm, title: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small">İçerik</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={noteForm.content}
                onChange={(e) =>
                  setNoteForm({ ...noteForm, content: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small">Öncelik</Form.Label>
              <Form.Select
                value={noteForm.priority}
                onChange={(e) =>
                  setNoteForm({ ...noteForm, priority: e.target.value })
                }
              >
                <option value="Normal">Normal</option>
                <option value="Yuksek">Yüksek</option>
                <option value="Kritik">Kritik</option>
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" size="sm" onClick={() => setModalType(null)}>
            İptal
          </Button>
          <Button variant="dark" size="sm" onClick={saveNote}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 3. Kalite Modalı */}
      <Modal
        show={modalType === "quality"}
        onHide={() => setModalType(null)}
        centered
        size="sm"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="fs-6 fw-bold">
            {isEditing ? "Madde Düzenle" : "Yeni Madde Ekle"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="small">Başlık</Form.Label>
              <Form.Control
                type="text"
                value={qualityForm.title}
                onChange={(e) =>
                  setQualityForm({ ...qualityForm, title: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="small">Açıklama</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={qualityForm.description}
                onChange={(e) =>
                  setQualityForm({
                    ...qualityForm,
                    description: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" size="sm" onClick={() => setModalType(null)}>
            İptal
          </Button>
          <Button variant="dark" size="sm" onClick={saveQuality}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}
